import { StartExercise, UpdateObjective } from "Phaser/EventBus";
import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";
import { Event, Exercise, Lecture, NoTimeExercise, PianoScene, Section, StaffExercise, Tutorial } from "Utils/TutorialConfigHelper";
import timestamps from "./level20.json";

const Level20 = Tutorial(20, '2:53.5', [
  Section([
    Lecture('B in the Treble Clef', '0:00'),
    Lecture('B on the Keyboard', '0:26'),
    Exercise('Find B', '0:38', PianoScene({
      objectives: [
        {
          target: 'B4',
          text: 'Play B on your keyboard.'
        }
      ]
    }), [
    ])
  ]),
  Section([
    Lecture('Shifting to E Position', '0:44'),
    Exercise('E Position', '0:54', NoTimeExercise({
      centre_align_horizontal: true,
      objectives: [{}, {}]
    }),
      [
      ]),
    Exercise('Playing in Time', '1:07', StaffExercise({
      objectives: [
        {},
        {},
      ]
    }), [
    ])
  ]),
  Section([
    Lecture('Using Both Hands', '1:19'),
    Exercise('Hands Together', '1:28', StaffExercise(
      {
        objectives: [{}, {}]
      }
    ), [
    ])
  ]),
  Section([
    Lecture('Seven Notes in the Right Hand', '1:38'),
    Exercise('Playing C to B', '1:48', NoTimeExercise({
      centre_align_horizontal: true,
      objectives: [{}, {}]
    }), [
    ]),
    Lecture('Seven Note Stretch', '2:03'),
    Exercise('Playing in Time', '2:21', StaffExercise({
      objectives: [{}, {}]
    }), [
    ])
  ]),
  Section([
    Lecture('Using Both Hands', '2:32'),
    Exercise('Alternating Hands', '2:38', StaffExercise({
      objectives: [{}]
    }), [
    ]),
    Exercise('Hands Together', '2:45', StaffExercise({
      objectives: [{}, {}]
    }), [
    ]),
  ])
]);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level20);
